export const getTableMode = (state) => {
  return state.tableMode;
};
export const getDetailsIsActive = (state) => {
  return state.detailsIsActive;
};
export const getDetailsId = (state) => {
  return state.detailsId;
};
export const getFiltersTabIsActive = (state) => {
  return state.filtersTabIsActive;
};
export const getPreferencesModalIsActive = (state) => {
  return state.preferencesModalIsActive;
};
export const getPreferencesId = (state) => {
  return state.preferencesId;
};

// FILTERS
export const getSearchFilter = (state) => {
  return state.searchFilter;
};
export const getActiveFilters = (state) => {
  return state.activeFilters;
};
